// Recovered compiled webpack factory 72421. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "isDynamicRoute", {
      enumerable: !0,
      get: function () {
        return i;
      },
    }));
  let n = r(57630),
    a = /\/[^/]*\[[^/]+\][^/]*(?=\/|$)/,
    o = /\/\[[^/]+\](?=\/|$)/;
  function i(e, t) {
    return (void 0 === t && (t = !0),
    (0, n.isInterceptionRouteAppPath)(e) &&
      (e = (0, n.extractInterceptionRouteInformation)(e).interceptedRoute),
    t)
      ? o.test(e)
      : a.test(e);
  }
}
